import { render, staticRenderFns } from "./ProductGroupForm.vue?vue&type=template&id=1273f0a4"
import script from "./ProductGroupForm.vue?vue&type=script&lang=js"
export * from "./ProductGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports